import templateUrl from './change-password.html';
import find from 'lodash/find';

export const changePasswordComponent = {
	templateUrl,
	controller: class ChangePasswordComponent {
		constructor($state, AuthService, toastr, ModalService) {
			'ngInject';

			this.authService = AuthService;
			this.toastr = toastr;
			this.$state = $state;
			this.modalService = ModalService;
			//this.Constants = Constants;
		}
		$onInit() {
			this.misMatchPassword = false;
			this.invalidOldPassword = false;
			this.invalidNewPassword = false;
		}
		onSubmit() {
			if (this.details.newPassword != this.details.reTypePassword) {
				this.invalidNewPassword = true;
				this.invalidNewPasswordErrorMessage = "New password and re-type password doesn't match";
			} else {
				this.disableButtons = true;
				this.authService.updatePassword(this.details).then((details) => {
					this.toastr.success("password updated successfully");
					this.$state.go("app.dashboard.HomeBanner");
				}).catch((error) => {
					this.disableButtons = false;
					if (error.data) {
						const invalidOldPasswordError = find(error.data, ['key', "old_password"]);
						if (invalidOldPasswordError) {
							this.invalidOldPassword = true;
							this.invalidOldPasswordErrorMessage = invalidOldPasswordError.message;
						}
						const invalidNewPasswordError = find(error.data, ['key', "new_password"]);
						if (invalidNewPasswordError) {
							this.invalidNewPassword = true;
							this.invalidNewPasswordErrorMessage = invalidNewPasswordError.message;
						}
					} else {
						this.invalidOldPassword = true;
						this.invalidOldPasswordErrorMessage = error.message;
					}
				})
			}
		}

		onCancel() {
			if (this.details === undefined) {
				this.$state.go("app.dashboard.HomeBanner");
			} else {
				this.modalService.open({
					details: {
						bodyMessage: 'Changes done will be reverted. Continue?'
					},
					buttons: [{
						name: 'No',
						action() {
						}
					}, {
						name: 'Yes',
						isPrimary: true,
						action: _onSubmit.bind(this)
					}]
				});

				function _onSubmit() {
					this.$state.go('app.dashboard');
				}
			}
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/components/auth/change-password/change-password.component.js